import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  readonly toggleMenu$: Observable<boolean>;
  private readonly _toggleMenu$: BehaviorSubject<boolean> = new BehaviorSubject(
    false
  );

  constructor() {
    this.toggleMenu$ = this._toggleMenu$.asObservable();
  }

  setToggleMenu(isOpen: boolean): void {
    this._toggleMenu$.next(isOpen);
  }
}
